import { render, staticRenderFns } from "./Validadorlog.vue?vue&type=template&id=30b67bcc"
import script from "./Validadorlog.js?vue&type=script&lang=js&external"
export * from "./Validadorlog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports